module.exports = __webpack_public_path__ + "static/media/dr_logo4.a4208957.png";